import { gql } from 'graphql-request'

export const GET_GENNERATE_COUPONS = gql`
  query PromotionCode($promotionId: Float!) {
    promotion(id: $promotionId) {
      generateCouponStatus
    }
  }
`
